/*eslint-disable*/
import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { selectUserData } from '../../Redux/UserSlice';
import { Rating } from "react-simple-star-rating";
import Swal from "sweetalert2";
import { FormGroup } from "react-bootstrap";
import { api_url } from '../../Constants/web_services';
import Form from "react-bootstrap/Form";


const OrderReviewForm = ({ order, index }) => {
    // const userData = useSelector(selectUserData);

    const [review, setReview] = useState("");
    const [descReview, setDescReview] = useState("");
    const [qualityRating, setQualityRating] = useState(0);
    const [responseTimeRating, setResponseTimeRating] = useState(0);
    const [timelineRating, setTimelineRating] = useState(0);


    const onPointerEnter = () => console.log();
    const onPointerLeave = () => console.log();
    const onPointerMove = (value, index) => console.log();

    const handleQualityRating = (value) => {
        setQualityRating(value);
    };

    const handleResponseTimeRating = (value) => {
        setResponseTimeRating(value);
    };

    const handleTimelineRating = (value) => {
        setTimelineRating(value);
    };

    const handleOrderReview = async (e) => {
        e.preventDefault();

        // Create the data object manually
        const formData = new FormData(e.target);
        const orderId = parseInt(formData.get('order_id'), 10);
        const companyId = parseInt(formData.get('company_id'), 10);

        const reviewData = {
            review: review,
            desc_review: descReview,
            quality: parseFloat(qualityRating), // Ensure numeric type
            response_time: parseFloat(responseTimeRating), // Ensure numeric type
            timeline: parseFloat(timelineRating), // Ensure numeric type
        };
        const token = localStorage.getItem('token');

        try {
            const res = await fetch(`${api_url}/api/order-review-submit/${orderId}/${companyId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(reviewData),
            });

            if (res.ok) {
                const response = await res.json();
                console.log("Full response:", response);

                if (response.status === "success") {
                    setReview('');
                    setDescReview('');
                    setQualityRating('');
                    setResponseTimeRating('');
                    setTimelineRating('');

                    Swal.fire({
                        title: "Success!",
                        text: "Your review has been submitted successfully.",
                        icon: "success",
                        confirmButtonText: "OK",
                    }).then(() => {
                        setTimeout(() => {
                            window.location.reload();
                        }, 4000); // Reload after 3 seconds
                    });

                } else {
                    console.error("Review submission failed:", response.message);
                }
            } else {
                console.error(`HTTP error! Status: ${res.status}`);
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    };


    return (
        <div className="py-3 bg-warning sf-radius-10 " key={index}>
            <div className="row justify-content-center">
                <div className="col-md-10 mt-4">
                    <Form
                        onSubmit={
                            handleOrderReview
                        }
                    >
                        <Form.Group
                            className="mb-4 "
                            controlId="exampleForm.ControlTextarea1"
                        >
                            <Form.Label className="fw-600 ">
                                <button
                                    disabled
                                    className="admin-button bg-primary text-light assignButton margin-r-10 mb-3"
                                >
                                    <i
                                        className="fa fa-american-sign-language-interpreting p-2"
                                        style={{
                                            fontSize:
                                                "25px",
                                        }}
                                    />
                                    Please Review And Rate Us For Better Outcome
                                </button>
                            </Form.Label>
                            <div className="row justify-content-between">
                                <div className="col-8 ">
                                    <label>Review in 2 lines</label>

                                    <Form.Control
                                        as="textarea"
                                        placeholder="Review"
                                        value={descReview}
                                        onChange={(e) =>
                                            setDescReview(
                                                e.target.value
                                            )
                                        }
                                        // rows={1}
                                        style={{ minHeight: '50px', backgroundColor: 'white', color: '#676767', paddingTop: '12px' }}
                                    />
                                </div>
                                <div className="col-4 ">
                                    <label>In one word...</label>

                                    <Form.Select
                                        size="lg"
                                        style={{ minHeight: '50px', color: '#676767', backgroundColor: 'white' }}
                                        as="select"
                                        value={review}
                                        onChange={(e) => setReview(e.target.value)}
                                    >
                                        <option>SELECT</option>
                                        <option value="Responsive">Responsive</option>
                                        <option value="Good service">Good service</option>
                                        <option value="Polite">Polite</option>
                                        <option value="Best At Work">Best At Work</option>
                                        <option value="Compatible Price">Compatible Price</option>
                                        <option value="Excellent">Excellent</option>
                                        <option value="Professional">Professional</option>
                                        <option value="Highly Recommend">Highly Recommend</option>
                                        <option value="Satisfactory">Satisfactory</option>
                                        <option value="Reliable">Reliable</option>
                                        <option value="Timely">Timely</option>
                                        <option value="Courteous">Courteous</option>
                                        <option value="Exceeded Expectations">Exceeded Expectations</option>
                                        <option value="Quality Service">Quality Service</option>
                                        <option value="Fair Pricing">Fair Pricing</option>
                                        <option value="Efficient">Efficient</option>
                                        <option value="Trustworthy">Trustworthy</option>
                                        <option value="Knowledgeable">Knowledgeable</option>
                                        <option value="Responsive">Responsive</option>
                                        <option value="Great Communication">Great Communication</option>
                                        <option value="Detail-Oriented">Detail-Oriented</option>
                                        <option value="Friendly">Friendly</option>
                                        <option value="Helpful">Helpful</option>
                                        <option value="Outstanding">Outstanding</option>
                                        <option value="Skilled">Skilled</option>
                                        <option value="Worth the Cost">Worth the Cost</option>
                                        <option value="Exceptional">Exceptional</option>
                                        <option value="Customer Focused">Customer Focused</option>

                                    </Form.Select>
                                </div>
                            </div>
                        </Form.Group>
                        <FormGroup>
                            <div className="row ps-0 justify-content-between">
                                <div className="col-4 ">
                                    <h6>Quality</h6>
                                    <Rating
                                        style={{ backgroundColor: 'white', padding: '2px' }}
                                        className='sf-radius-10 '
                                        value={qualityRating} // Assuming qualityRating is the state variable for quality rating
                                        onClick={handleQualityRating}
                                        onPointerEnter={onPointerEnter}
                                        onPointerLeave={onPointerLeave}
                                        onPointerMove={onPointerMove}
                                    />
                                </div>
                                <div className="col-4 ">
                                    <h6>Response Time</h6>

                                    <Rating
                                        style={{ backgroundColor: 'white', padding: '2px' }}

                                        className='sf-radius-10'
                                        value={responseTimeRating} // Assuming responseTimeRating is the state variable for response time rating
                                        onClick={handleResponseTimeRating}
                                        onPointerEnter={onPointerEnter}
                                        onPointerLeave={onPointerLeave}
                                        onPointerMove={onPointerMove}
                                    />
                                </div>
                                <div className="col-4 ">
                                    <h6>Timeline</h6>

                                    <Rating
                                        style={{ backgroundColor: 'white', padding: '2px' }}

                                        className='sf-radius-10'
                                        value={timelineRating} // Assuming timelineRating is the state variable for timeline rating
                                        onClick={handleTimelineRating}
                                        onPointerEnter={onPointerEnter}
                                        onPointerLeave={onPointerLeave}
                                        onPointerMove={onPointerMove}
                                    />
                                </div>
                                <Form.Control
                                    as="input"
                                    type="hidden"
                                    name="order_id"
                                    value={order?.id} />

                                <Form.Control
                                    as="input"
                                    type="hidden"
                                    name="company_id"
                                    value={order?.company?.id} />
                            </div>

                            <div className="col-12 text-center mt-3">
                                <button
                                    type="submit"
                                    className="admin-button bg-primary text-light assignButton margin-r-10 mt-2"
                                // style={{ backgroundColor: '#50D9FF' }}
                                >
                                    <i className="fa fa-poll-h me-2" />
                                    Submit Review
                                </button>
                            </div>
                        </FormGroup>

                    </Form>
                </div>
                <div className="col-md-12">
                    <div className="row justify-content-center"></div>
                </div>
            </div>
        </div>
    )
}

export default OrderReviewForm
